import React, {Component} from "react";
import {Col, ControlLabel, Form, FormControl, FormGroup, InputGroup, Row} from "react-bootstrap";
import {TopButtonAction} from "../../../../../../componentsTopsa/buttons/TopButtons";
import WyborKlientForm from "../../../../../klienciConfig/klienci/externalComponents/WyborKlientForm";
import initialData from "../../../../../../utilities/initialData/initialData";

export default class DefiniowanieZamawiajacegoForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            czyPrzekazanyKlient: false,
            wybranyKlient: initialData.returnKlientJednorazowyObject(),
            jednorazowyObject:{idKl:1,czyKlientJednorazowy:true,zamawiajacy:'',email:null,telefon:null,zamawiajacyNazwisko:'',zamawiajacyImie:''}
        }
        this.onClickZmienKlienta = this.onClickZmienKlienta.bind(this)
        this.onChangeKlient = this.onChangeKlient.bind(this)
        this.onChangeJednorazowyObject = this.onChangeJednorazowyObject.bind(this)
    }

    componentDidMount() {
        this.initJednorazowyKlient()
        if (Boolean(this.props.klientZLocalStorage)) {
            this.setState({
                czyPrzekazanyKlient: true,
                wybranyKlient: this.props.klientZLocalStorage
            })
        }
    }

    componentWillReceiveProps(nextprops) {
        if (Boolean(nextprops.klientZLocalStorage)) {
            this.setState({
                czyPrzekazanyKlient: true,
                wybranyKlient: nextprops.klientZLocalStorage
            })
        }
    }

    initJednorazowyKlient() {
        this.setState({
            wybranyKlient: initialData.returnKlientJednorazowyObject()
        })
    }

    renderKlientOption(option, czyPokazacZdj) {
        return <div>
            {Boolean(czyPokazacZdj) ? Boolean(option.zdjecie) ?
                <div title={'zdjęcie klienta'} style={{display: 'inline-block', marginRight: '15px'}}>
                    <img src={'data:image/jpg;base64,' + option.zdjecie} style={{width: '40px'}}/>
                </div>
                :
                <div title={'brak zdjęcia'} style={{display: 'inline-block', marginRight: '15px', width: '40px', minHeight: '1px'}}></div>
                :
                ''
            }
            {Boolean(option.imie) ?
                <span title={'Imie i nazwisko klienta'}><span className={'label label-ebus-primary'}>{option.imieNazwisko}</span></span> : ''}
            {Boolean(option.pesel) ?
                <span title={'PESEL'} style={{marginLeft: '15px'}}><i className={'fa fa-id-card-o'}></i> {option.pesel}</span> : ''}
            {Boolean(option.email) ?
                <span title={'Email'} style={{marginLeft: '15px'}}><i className={'fa fa-envelope'}></i> {option.email}</span> : ''}
            {Boolean(option.nrTel) ?
                <span title={'Telefon'} style={{marginLeft: '15px'}}><i className={'fa fa-phone'}></i> {option.nrTel}</span> : ''}
        </div>
    }

    onClickZmienKlienta() {
        // trzeba wykasować klienta z klientZLocalStorage
        this.setState({wybranyKlient: null})
        this.initJednorazowyKlient();
    }

    onChangeKlient(obj) {
        this.setState({wybranyKlient: obj})
        this.props.handleChangeKlient(obj)
    }

    onChangeJednorazowyObject(e,key){
        let obj = this.state.jednorazowyObject
        obj[key] = e.target.value

        if(key === "email" || key ==="telefon"){
            if(e.target.value.length === 0){
                obj[key] = null
            }
        }
        this.setState({jednorazowyObject:obj})
        this.props.handleJednorazowyObject(obj)
    }

    render() {
        return (
            <div style={{marginTop: '15px'}}>
                <fieldset>
                    <div className={'fieldset-label'}>Szczegóły klienta</div>
                    <Form horizontal={true}>
                        {
                            Boolean(this.state.czyPrzekazanyKlient) ?    // gdy klient jest pobierany z localStorage
                                <FormGroup>
                                    <Col xs={12} lg={12}>
                                        <label style={{marginRight: '15px'}}>
                                            Wybrany klient:
                                        </label>
                                        {this.renderKlientOption(this.props.klientZLocalStorage, true)}
                                    </Col>
                                    {/*<Col xs={12} lg={12}>
                                        <div style={{marginTop: '15px'}}>
                                            <TopButtonAction iconType={'fa fa-user-plus'}
                                                             btnSize={'medium'}
                                                             text={'Zmień klienta'}
                                                             onClick={this.onClickZmienKlienta}/>
                                        </div>
                                    </Col>*/}
                                </FormGroup>
                                :   // jeśli klient jest wybierany z pola wyboru lub ma być jednorazowy
                                Boolean(this.state.wybranyKlient) ?

                                    // gdy klient jest jednorazowy
                                    <FormGroup>
                                        <Col xs={12} lg={4}>
                                            <WyborKlientForm handleChangeKlient={this.onChangeKlient} dostosujPodJednorazowe={true}
                                                             klient={this.state.wybranyKlient}/>
                                        </Col>
                                        {
                                            Boolean(this.state.wybranyKlient.idKl == 1) ?
                                                <Col xs={12} lg={8}>
                                                    <Row>
                                                        <Col xs={12} lg={2}>
                                                            <ControlLabel style={{marginBottom:'7px'}}>
                                                                Imie zamawiającego <span className={'req'}>*</span>
                                                            </ControlLabel>
                                                            <FormControl type="text" onChange={(e)=>this.onChangeJednorazowyObject(e,'zamawiajacyImie')}/>
                                                        </Col>
                                                        <Col xs={12} lg={3}>
                                                            <ControlLabel style={{marginBottom:'7px'}}>
                                                                Nazwisko zamawiającego <span className={'req'}>*</span>
                                                            </ControlLabel>
                                                            <InputGroup>
                                                                <FormControl type="text" onChange={(e)=>this.onChangeJednorazowyObject(e,'zamawiajacyNazwisko')}/>
                                                                <InputGroup.Addon><i className={'fa fa-user'}></i></InputGroup.Addon>
                                                            </InputGroup>
                                                        </Col>
                                                        <Col xs={12} lg={3}>
                                                            <ControlLabel style={{marginBottom:'7px'}}>
                                                                Telefon
                                                            </ControlLabel>
                                                            <InputGroup>
                                                                <FormControl type="number"  onChange={(e)=>this.onChangeJednorazowyObject(e,'telefon')}/>
                                                                <InputGroup.Addon><i className={'fa fa-phone'}></i></InputGroup.Addon>
                                                            </InputGroup>
                                                        </Col>
                                                        <Col xs={12} lg={3}>
                                                            <ControlLabel style={{marginBottom:'7px'}}>
                                                                Email
                                                            </ControlLabel>
                                                            <InputGroup>
                                                                <FormControl type="email"  onChange={(e)=>this.onChangeJednorazowyObject(e,'email')}/>
                                                                <InputGroup.Addon><i className={'fa fa-envelope'}></i></InputGroup.Addon>
                                                            </InputGroup>

                                                        </Col>
                                                    </Row>
                                                </Col>
                                                :
                                                ''
                                        }
                                    </FormGroup>
                                    :
                                    ''
                        }
                    </Form>
                </fieldset>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/dodajBiletJednorazowy/components/definiowanieZamawiajacego/DefiniowanieZamawiajacegoForm.js